export class Modifier {
  type: string;
  value: number;
  cappedAmount: number;

  constructor(type: string, value: number, cappedAmount: number = 0) {
    this.type = type;
    this.value = value;
    this.cappedAmount = cappedAmount;
  }

  getModifiedPrice(price: number): number {
    if (this.type === "percentage") {
      return this._getModifiedPriceForPercentage(price);
    }

    return this._getModifiedPriceForFixed(price);
  }

  _getModifiedPriceForPercentage(price: number): number {
    const priceInCents = price * 100;
    const modifiedPriceInCents = priceInCents * this.value;
    const roundedModifiedPriceInCents = Math.round(modifiedPriceInCents);
    const priceWithCappedAmountInCents = priceInCents + this.cappedAmount;

    if (roundedModifiedPriceInCents > priceWithCappedAmountInCents) {
      return priceWithCappedAmountInCents / 100;
    }

    return roundedModifiedPriceInCents / 100;
  }

  _getModifiedPriceForFixed(price: number): number {
    return price + this.value / 100;
  }

  getComputedValue(price: number): number {
    const modifiedPrice = this.getModifiedPrice(price);

    return modifiedPrice - price;
  }
}
